/* Les Intentionnelles : membres qui témoignent. Flèches des rails + fenêtre qui charge le post Instagram seulement au clic (aucun script ni cookie Instagram avant). */
(function () {
  function embedUrl(u) {
    var m = String(u || '').match(/instagram\.com\/(p|reel|tv)\/([A-Za-z0-9_-]+)/);
    return m ? 'https://www.instagram.com/' + m[1] + '/' + m[2] + '/embed/' : '';
  }
  function init(root) {
    if (root.__it) return; root.__it = true;
    root.querySelectorAll('[data-it-group]').forEach(function (g) {
      var rail = g.querySelector('[data-it-rail]'), prev = g.querySelector('[data-it-prev]'), next = g.querySelector('[data-it-next]');
      if (!rail) return;
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      function step(d) { rail.scrollBy({ left: d * Math.max(rail.clientWidth * 0.8, 220), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
    var dlg = root.querySelector('[data-it-dialog]'); if (!dlg) return;
    var frame = dlg.querySelector('[data-it-frame]'), link = dlg.querySelector('[data-it-link]'), last = null;
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { frame.innerHTML = ''; if (last && last.focus) last.focus(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    var x = dlg.querySelector('[data-it-close]'); if (x) x.addEventListener('click', close);
    root.querySelectorAll('[data-it-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-url'), src = embedUrl(url);
        last = b;
        if (!src) { if (url) window.open(url, '_blank', 'noopener'); return; }
        frame.innerHTML = '';
        var f = document.createElement('iframe');
        f.src = src; f.setAttribute('loading', 'lazy'); f.setAttribute('allowfullscreen', ''); f.setAttribute('title', b.getAttribute('data-name') || 'Instagram');
        frame.appendChild(f);
        if (link) link.href = url;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else window.open(url, '_blank', 'noopener');
      });
    });
  }
  function boot() { document.querySelectorAll('[data-it]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
